import React from 'react';
import { Chip } from '@mui/material';
import { 
  CheckCircle as CheckCircleIcon,
  PlayCircleOutline as PlayCircleOutlineIcon
} from '@mui/icons-material';

const ExamStatusBadge = ({ 
  status, 
  size = "small", 
  variant = "filled",
  showIcon = false,
  sx = {} 
}) => {
  if (!status) return null;

  const isCompleted = status === "completed";
  const iconProps = { fontSize: size === 'small' ? 'small' : 'medium' };

  const statusConfig = isCompleted ? {
    label: "Completed",
    color: "#4CAF50",
    icon: showIcon ? <CheckCircleIcon {...iconProps} /> : null
  } : {
    label: "In Progress", 
    color: "#FF9800",
    icon: showIcon ? <PlayCircleOutlineIcon {...iconProps} /> : null
  };

  return (
    <Chip
      label={statusConfig.label}
      icon={statusConfig.icon}
      size={size}
      variant={variant === "outlined" ? "outlined" : undefined}
      sx={{
        borderRadius: 2,
        fontWeight: 500,
        ...(variant === "outlined" ? {
          borderColor: statusConfig.color,
          color: statusConfig.color,
          backgroundColor: "transparent",
        } : {
          backgroundColor: statusConfig.color,
          color: "white",
        }),
        "& .MuiChip-label": {
          px: showIcon ? 1 : 1.5,
        },
        "& .MuiChip-icon": {
          color: variant === "outlined" ? statusConfig.color : "white",
        },
        ...sx
      }}
    />
  );
};

export default ExamStatusBadge;
